export const config = _sys => {
  return {
    change: {
      debounce: 100
    }
  };
};